export default __webpack_public_path__ + "static/media/twitter.0453078c.svg";